module.exports = __webpack_public_path__ + "img/be.c1d543d2.png";